<template>
  <b-card>

    <h5 v-if="canViewTitle">{{ title }}</h5>

    <FormAddProcesos 
      v-if="canAddProcesos"
      :procesosList="procesosList"
      :esIess="esIess"
    />

    <CardEnvioProcesos 
      :procesosList="procesosList"
      :onlyView="onlyView"
    />

    <b-alert 
      v-if="alertNoRegistros && !procesosList.length" 
      variant="danger" 
      show 
      class="text-center col-12 my-2"
      style="padding: 40px; font-size: 20px;">
      <i class="fa-solid fa-triangle-exclamation" />
      No ha registrado ningun proceso clinico
    </b-alert>
    
    <EditarEnvioProceso
      :isVisible.sync="showModalEdit"
      :indexProceso="indexToEdit"
      :procesosList="procesosList"
    />
  </b-card>
</template>

<script>
import 'flatpickr/dist/flatpickr.css';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { procedimientosService } from '@/views/procesoclinico/services';

import EditarEnvioProceso from '@/views/procesoclinico/components/RegistrarEnvioProcesos/EditarEnvioProceso.vue';
import CardEnvioProcesos from '@/views/procesoclinico/components/RegistrarEnvioProcesos/CardEnvioProcesos.vue';
import FormAddProcesos   from './FormAddProcesos.vue';

export default {

  name: "RegistrarEnvioProcesos",


  props:{

    procesosListParent: {
      type: Array,
      default: () => []
    },

    saveInState: {
      type: Function,
      default: () => {}
    },

    tokenAtencion: {
      type: String,
      default: null  
    },

    esIess:{
      type:Boolean,
      default: false
    },

    maxEnvios: {
      type: Number,
      default: null 
    },


    alertNoRegistros: {
      type: Boolean,
      default: false
    },

    respaldo: {
      type: Array,
      default: () => []
    },

    title:{
      type: String,
      default: null
    },

    onlyView: {
      type: Boolean,
      default: false
    }

  },

  components: {
    EditarEnvioProceso,
    CardEnvioProcesos,
    FormAddProcesos
  },

  created() {
    this.loadData();

    if(this.respaldo?.length){
      console.log("RESPALDO", this.respaldo)
      this.procesosList = [...this.respaldo];
    }
  },

  data() {
    return {
      procesosList  : [],
      indexToEdit   : null,
      showModalEdit : false,
      procedimientosService,
    };
  },


  methods: {

    async loadData(){
 
      if(this.tokenAtencion){
        const responseProcedimientos = await procedimientosService.getByAtencion(this.tokenAtencion);

        console.log("RESPONSE PROCEDIMIENTOS", responseProcedimientos)

        if(!responseProcedimientos) return;

        // map
        this.procesosList = responseProcedimientos.map(proceso => {

          let procedimiento = null
          let odonto = false

          if (proceso && proceso.procedimiento) {
            odonto = false
          procedimiento = {
            text : `(${proceso.procedimiento.codigo}) ${proceso.procedimiento.descripcion}`,
            value: proceso.procedimiento.id,
            cod  : proceso.procedimiento.codigo
          }
          }

          if (proceso && proceso.procedimientoOdonto) {
            odonto = true
          procedimiento = {
            text : `(${proceso.procedimientoOdonto.codigo}) ${proceso.procedimientoOdonto.descripcion}`,
            value: proceso.procedimientoOdonto.id,
            cod  : proceso.procedimientoOdonto.codigo
          }
          }

          return {
            action              : 'registrado',
            odonto              : odonto,
            procedimiento       : procedimiento,
            numeroOrden         : proceso.noas400,
            motivoSolicitud     : proceso.motivoSolicitud,
            resumenClinico      : proceso.resumenClinico,
            justificacion       : proceso.justificacion,
            idRegistro          : proceso.id,
            estadoProcedimiento : proceso.estadoProceso
          };
        });
      }
    },


    onEditProceso(index) {
      this.showModalEdit = true;
      this.indexToEdit = index;
    },


    async removeProceso(index) {

      const result = await this.$swal({
        title: 'Eliminar Proceso Clínico',
        text : '¿Está seguro de eliminar el proceso clínico?',
        icon : 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, Eliminar',
        cancelButtonText: 'No, Cancelar',
        confirmButtonColor: '#d33',
      });

      if (!result.isConfirmed) return;
      
      const procesoIndex = this.procesosList[index];

      if(procesoIndex.token){
        procesoIndex.activo = false;
        procesoIndex.edited = true;
        this.procesosList.splice(index, 1, procesoIndex);
        return;
      }

      this.procesosList.splice(index, 1);
    },

  },


  computed: {

    canAddProcesos() {
      if (this.onlyView) return false;
      return this.maxEnvios === null || this.procesosList.length < this.maxEnvios;
    },


    canViewTitle() {
      if(this.onlyView && !this.procesosList.length) return false;
      return true;
    }

  },

  watch: {

    procesosList:{
      deep: true,
      handler(newValue) {
        this.saveInState(newValue);
      }
    },


    tokenAtencion(newValue) {
      if(newValue) this.loadData();
    },

  }

}
</script>
